import Web3Services from 'Backend/Web3'
import Swal from 'sweetalert2'
// import { i18n } from 'react-i18next'
import { METAMASK_STATUS, TOMO_NETWORK } from 'Utils/globalConstants'
import { getCurrentBrowserLanguage } from 'Utils/globalFunction'
import { store } from 'Backend/Redux/store/configureStore'
import * as globalActions from 'Backend/Redux/actions/globalActions'
const window = require('global/window')
const web3 = window.tomoWeb3 || window.web3
let reduxState = store.getState()
store.subscribe(() => {
  reduxState = store.getState()
})

export default class ReduxServices {
  static async refreshMetaMask () {
    const checkMetaMask = () => {
      return new Promise ((resolve, reject) => {
        const { metamask } = reduxState
        let newStatus = Object.assign({}, metamask)
        try {
          if (typeof web3 === 'undefined') {
            newStatus.status = METAMASK_STATUS.NOWEB3
            newStatus.network = 0
            delete newStatus.account
            resolve(newStatus)
          } else {
            // Get metamask ether network
            let p1 = new Promise((resolve, reject) => {
              try {
                web3.version.getNetwork((err, network) => {
                  if (err) return reject(err)
                  return resolve(network)
                })
              } catch (e) {
                return reject(e)
              }
            })
            // Close p1 promise if over time
            let p2 = new Promise(function (resolve, reject) {
              setTimeout(() => {
                return reject('request timeout')
              }, 3000)
            })
            Promise.race([p1, p2]).then((networkNew) => {
              const networkParse = parseInt(networkNew)
              const findNetwork = TOMO_NETWORK.find(itm => itm.key === networkParse)
              let network = (findNetwork ? findNetwork.key : 'Unknown')

              web3.eth.getAccounts((err, accounts) => {
                if (err) {
                  newStatus.status = METAMASK_STATUS.ERROR
                  newStatus.network = network
                  delete newStatus.account
                  resolve(newStatus)
                } else if (accounts && accounts.length > 0) {
                  newStatus.status = METAMASK_STATUS.READY
                  newStatus.network = network
                  newStatus.account = accounts[0].toLowerCase()
                  resolve(newStatus)
                } else {
                  newStatus.status = METAMASK_STATUS.LOADING
                  newStatus.network = 0
                  delete newStatus.account
                  resolve(newStatus)
                }
              })
            }).catch((e) => {
              newStatus.status = METAMASK_STATUS.LOCKED
              newStatus.network = 0
              delete newStatus.account
              resolve(newStatus)
            })
          }
        } catch (error) {
          newStatus.status = METAMASK_STATUS.ERROR
          newStatus.network = 0
          delete newStatus.account
          resolve(newStatus)
        }
      })
    }
    const { userAuth, metamask } = reduxState
    const newMetamaskStatus = await checkMetaMask()
    let isSigned = this.checkIsSigned(userAuth, newMetamaskStatus)

    if (((newMetamaskStatus && newMetamaskStatus.status) !== metamask.status) ||
      ((newMetamaskStatus && newMetamaskStatus.isSigned) !== isSigned) ||
      (newMetamaskStatus && newMetamaskStatus.account !== metamask.account)) {
      newMetamaskStatus.isSigned = isSigned
      store.dispatch(globalActions.setMetaMask(newMetamaskStatus))

      if (newMetamaskStatus.status === METAMASK_STATUS.LOADING || (newMetamaskStatus.account && userAuth.address && newMetamaskStatus.account !== userAuth.address)) {
        this.resetUser()
      }
    }
  }
  static checkIsSigned (userAuth, metamask) {
    if ((userAuth && userAuth.address && userAuth.address.length > 0) && metamask) {
      return (metamask.account === userAuth.address.toLowerCase())
    } else {
      return false
    }
  }
  static loginMetamask (callback = null, i18n = null, callbackErr = null) {
    return new Promise (async (resolve, reject) => {
      const signMetaMask = (callback = null) => {
        return new Promise (async (resolve, reject) => {
          try {
            const { metamask } = reduxState
            if (metamask && metamask.account) {
              let message = 'Sign Message'
              let content = await Web3Services.onSignMessage(metamask.account, message.data ? message.data : '')
              if (content && content.address && content.signature) {
                let newUserLogin = Object.assign({}, { address: content.address, signature: content.signature + '|' + content.address })
                store.dispatch(globalActions.setUserAuthentication(newUserLogin))

                // Check already login user
                const newMetaMask = Object.assign({}, metamask)
                newMetaMask.isSigned = true
                store.dispatch(globalActions.setMetaMask(newMetaMask))

                callback && callback()
                return resolve(null)
              } else {
                Swal.fire({
                  width: '300px',
                  text: i18n('metamask.youNeedSignMessage'),
                  icon: 'warning',
                  showConfirmButton: false
                })
                store.dispatch(globalActions.setUserAuthentication({}))
                callbackErr && callbackErr()
                return resolve()
              }
            }
            return resolve()
          } catch (error) {
            reject(error)
          }
        })
      }

      const { metamask, userAuth } = reduxState
      try {
        // Check if MetaMask is installed
        if (metamask.status === TOMO_NETWORK.NOWEB3) {
          Swal.fire({
            width: '300px',
            text: i18n('metamask.pleaseInstallFirst'),
            icon: 'info',
            showConfirmButton: false
          })
          return resolve(null)
        }

        if (metamask.account && metamask.account.length > 0) {
          let isSigned = this.checkIsSigned(userAuth, metamask)
          if (!isSigned) {
            signMetaMask(callback)
          } else {
            callback && callback()
            return resolve(null)
          }
        } else {
          let resEnable = await Web3Services.enableMetaMask()
          if (resEnable.length > 0) {
            signMetaMask(callback)
          }
          return resolve(null)
        }
      } catch (error) {
        return resolve(error)
      }
    })
  }

  static resetUser () {
    return new Promise (async (resolve, reject) => {
      try {
        store.dispatch(globalActions.setUserAuthentication({}))
        resolve()
      } catch (error) {
        resolve(error)
      }
    })
  }

  static detectBrowserLanguage (i18n) {
    const lang = window.pantographLanguage || getCurrentBrowserLanguage()
    i18n.changeLanguage(lang)
    store.dispatch(globalActions.setLocale(lang))
  }
}